import React from "react";

export function AdminHeader({ title, subtitle, action }) {
  return (
    <div className="flex flex-col sm:flex-row sm:items-end justify-between gap-4 mb-8">
      <div>
        <h1 className="font-serif text-3xl text-white">{title}</h1>
        {subtitle && <p className="text-slate-400 text-sm mt-1">{subtitle}</p>}
      </div>
      {action}
    </div>
  );
}

export function Panel({ children, className = "" }) {
  return <div className={`bg-[#0B1D40] border border-[#203E70] rounded-md ${className}`}>{children}</div>;
}

export function TextInput({ label, hint, testid, ...props }) {
  return (
    <div>
      {label && <label className="text-sm text-slate-300 mb-1.5 block">{label}</label>}
      <input {...props} data-testid={testid} className="w-full bg-[#06122E] border border-[#203E70] rounded px-3 py-2.5 text-sm text-white focus:border-[#D8AE4E]/50 outline-none disabled:opacity-50" />
      {hint && <p className="text-xs text-slate-500 mt-1">{hint}</p>}
    </div>
  );
}

export function TextArea({ label, testid, ...props }) {
  return (
    <div>
      {label && <label className="text-sm text-slate-300 mb-1.5 block">{label}</label>}
      <textarea {...props} data-testid={testid} className="w-full bg-[#06122E] border border-[#203E70] rounded px-3 py-2.5 text-sm text-white focus:border-[#D8AE4E]/50 outline-none" />
    </div>
  );
}

export function EmptyState({ children }) {
  return <div className="text-center py-16 text-slate-500 text-sm">{children}</div>;
}
